import { c as _c } from "react/compiler-runtime";
import { Button, Heading, Picture, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';
import { getImageProps } from '../../../../utils/propsImagesItems';
import type { PromoCardProps } from '../types';
import './PromoCard.scss';
export function PromoCard(t0) {
  const $ = _c(24);
  const {
    header,
    image,
    bodyText,
    cta,
    backgroundFill: background,
    handleAnalytics
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = image && getImageProps(image);
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const img = t1;
  const Component = cta ? Link : "div";
  let t2;
  if ($[2] !== background) {
    t2 = {
      background
    };
    $[2] = background;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = cta?.link.webUrl ?? "";
  let t4;
  if ($[4] !== image || $[5] !== img) {
    t4 = img && image && <Picture {...img} />;
    $[4] = image;
    $[5] = img;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== header) {
    t5 = <Heading tagName="h2">{header}</Heading>;
    $[7] = header;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== bodyText) {
    t6 = <TextPassage>{bodyText}</TextPassage>;
    $[9] = bodyText;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== cta) {
    t7 = cta && <Button size="sm" text={cta.text} href={cta.link.webUrl} variant={cta.buttonStyle === "Primary" ? "primary" : "toolbar"} />;
    $[11] = cta;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className="c-promo-card__content">{t5}{t6}{t7}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== Component || $[18] !== handleAnalytics || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t8) {
    t9 = <Component style={t2} className="c-promo-card" data-testid="promo-card" href={t3} onClick={handleAnalytics} prefetch={false}>{t4}{t8}</Component>;
    $[17] = Component;
    $[18] = handleAnalytics;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}